/**
 * Ortak kompakt boyut: TabPage / DynamicList üst araç çubuğu aksiyon butonları.
 */
export const LIST_TOOLBAR_BTN =
  "h-8 shrink-0 whitespace-nowrap px-2 sm:px-2.5 rounded-md text-xs sm:text-sm font-medium border inline-flex items-center justify-center gap-1 sm:gap-1.5 transition-colors";

export const LIST_TOOLBAR_ICON = "w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0";

export const LIST_TOOLBAR_ROW =
  "flex flex-row flex-wrap items-center gap-1.5 sm:gap-2 w-auto max-w-full";
